import PropTypes from 'prop-types';

export const TrialBalanceThresholdPropTypes = PropTypes.shape({
  connectionName: PropTypes.string,
  trialBalanceThreshold: PropTypes.number,
});
